import React, { useState } from "react";
import { Container, Nav, Row } from "react-bootstrap";
import AllProjects from "../fakeData/AllProjects";
import "./../index.css";
import SingleWork from "./SingleWork";

const Portfolio = () => {
  const [category, setCategory] = useState("all");
  const [showMore, setShowMore] = useState(false);

  const categoryFiltered =
    category === "all"
      ? AllProjects
      : AllProjects.filter((item) => item.category === category);

  const visibleWorks = categoryFiltered.filter(
    (item) => showMore || item.tier === "core"
  );

  const hiddenCount = categoryFiltered.length - visibleWorks.length;

  return (
    <section className="portfolio-container" name="earlier-projects" id="earlier-projects">
      <div className="common pt-5" data-aos="fade-up">
        <h2 className="mainHeader mt-5">Earlier Projects</h2>
        <p className="mainContent">
          Personal and academic projects from earlier in my career.
        </p>
        <div className="commonBorder" />
      </div>

      <Nav className="projects-container" data-aos="fade-up">
        <div className="project-button-container mb-5">
          <button value="all" onClick={() => setCategory("all")}>
            All <span className="badge">{AllProjects.length}</span>
          </button>
          <button value="full-stack" onClick={() => setCategory("full-stack")}>
            Full Stack
          </button>
          <button value="front-end" onClick={() => setCategory("front-end")}>
            Front End
          </button>
        </div>
      </Nav>

      <Container>
        <Row>
          {visibleWorks.map((work, index) => (
            <SingleWork work={work} key={index} />
          ))}
        </Row>
      </Container>

      {hiddenCount > 0 && (
        <button
          className="button btn-outline show-more-btn"
          onClick={() => setShowMore(true)}
        >
          Show {hiddenCount} More Projects
        </button>
      )}
      {showMore && (
        <button
          className="button btn-outline show-more-btn"
          onClick={() => setShowMore(false)}
        >
          Show Less
        </button>
      )}
    </section>
  );
};

export default Portfolio;
